import { languages } from '../content/supportedLanguages'

export default function getLanguageLocale(languageCode) {
	if (typeof languageCode !== 'string') return languageCode

	const code = languageCode.toLowerCase()
	let locale = 'en'

	languages.forEach(language => {
		if (
			language.code === code &&
			language.locale &&
			language.locale !== ''
		) {
			locale = language.locale
		}
	})

	return locale
}


// WEBPACK FOOTER //
// ./src/utilities/language/getLanguageLocale.js